<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button :disabled="storageRoom.isNew()" content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(storageRoom.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="storageRoom" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.storageRoomNo')" prop="no">
              <vxe-input v-model="storageRoom.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.storageRoomName')" prop="name">
              <vxe-input v-model="storageRoom.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.storageRoomType')" prop="storageRoomType">
              <vxe-select v-model="storageRoom.storageRoomType" :options="storageRoomTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.storageEnvironment')" prop="storageEnvironment">
              <vxe-select v-model="storageRoom.storageEnvironment" :options="storageEnvironments" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.floor')" prop="floor">
              <vxe-input v-model="storageRoom.floor" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.tag')">
              <vxe-input v-model="storageRoom.tag" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.reservedLocations')">
              <vxe-number-input v-model="storageRoom.reservedLocations" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfPickingOrder')">
              <vxe-number-input v-model="storageRoom.numberOfPickingOrder" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfBarcode')">
              <vxe-number-input v-model="storageRoom.numberOfBarcode" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.exchangeStorageRoom')">
              <vxe-input v-model="storageRoom.exchangeStorageRoom.name" style="width: 100%" @clear="onInputChange(storageRoom,'exchangeStorageRoom')" @click="onStorageRoomSelect"/>
              <storage-room-modal ref="storageRoomModal" @change="(values)=>onInputChange(storageRoom,'exchangeStorageRoom',values[0])"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.containerType')">
              <vxe-select v-model="containerTypeIds" :options="containerTypes" multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.automatic')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.automatic"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.allocable')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.allocable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.aggregate')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.aggregate"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.weighable')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.weighable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.checkable')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.checkable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.separable')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.separable"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.serialNumberManagement')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.serialNumberManagement"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.caseOnly')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="storageRoom.caseOnly"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <shipment-rule-table ref="shipmentRuleTable" :item-types="itemTypes" :order-types="orderTypes" :owners="owners" :pack-types="packTypes"/>
    <replenishment-rule-table ref="replenishmentRuleTable" :transmission-types="transmissionTypes"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import ShipmentRuleTable from '@/views/basedata/storageroom/ShipmentRuleTable.vue'
import ReplenishmentRuleTable from '@/views/basedata/storageroom/ReplenishmentRuleTable.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  name: 'StorageRoomDetail',
  components: { ShipmentRuleTable, ReplenishmentRuleTable, StorageRoomModal },
  props: {
    storageRoomTypes: { type: Array, default: [] },
    storageEnvironments: { type: Array, default: [] },
    containerTypes: { type: Array, default: [] },
    packTypes: { type: Array, default: [] },
    transmissionTypes: { type: Array, default: [] },
    owners: { type: Array, default: [] },
    orderTypes: { type: Array, default: [] },
    itemTypes: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      storageRoom: new StorageRoom(),
      containerTypeIds: [],
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        storageRoomType: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        storageEnvironment: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        floor: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    onInputChange,
    back() {
      this.$emit('back')
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, storageRoomType: 9 })
    },
    build(result) {
      this.storageRoom = new StorageRoom(result)
      this.containerTypeIds = result && result.containerTypes ? result.containerTypes.map(item => item.id) : []
    },
    refresh(id) {
      this.loading = true
      findOne('storageRoomFactory', { id: id }).then(res => {
        if (res.success) {
          this.build(res.result)
          this.$refs.shipmentRuleTable.fetch(this.storageRoom)
          this.$refs.replenishmentRuleTable.fetch(this.storageRoom)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.build()
      this.storageRoom.available = true
    },
    save() {
      this.$refs.form.validate(success => {
        if (success) {
          this.loading = true
          const storageRoom = this.storageRoom.toJSONObject()
          storageRoom.warehouse = this.warehouse
          storageRoom.containerTypes = this.containerTypeIds ? this.containerTypeIds.map(item => {
            return { id: item }
          }) : []
          save('storageRoomPersister', storageRoom).then(res => {
            if (res.success) {
              this.build(res.result)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>